import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {BroadcastService, ClientConstants, ValidationService} from 'formbird-services';
import {Subscription} from 'rxjs';
import {ComponentDefinition} from '@formbird/types';

@Component({
  selector: 'ft-validation-display',
  templateUrl: './validation-message.component.html',
  styleUrls: ['./validation-message.component.scss'], 
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class ValidationMessageComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();

  @Input() model: any;
  @Input() componentDefinition: ComponentDefinition;

  validators: any[];
  validatorValue: any;

  fieldName: string;
  documentId: string;

  constructor(
    private validationService: ValidationService,
    private broadcastService: BroadcastService,
    private cdr: ChangeDetectorRef
  ) {
  }

  private loadData() {
    const self = this;

    if (!self.model || !self.componentDefinition) {
      console.warn('No model or template item provided for component.');
      return;
    }

    self.fieldName = self.componentDefinition.name;
    self.documentId = self.model.documentId;
    self.validators = self.validationService.loadValidators(self.componentDefinition, self.fieldName);
    self.validatorValue = self.validationService.validationCtrlValues;

    const subscription: Subscription = self.broadcastService.on(ClientConstants.VALIDATE_FORM_FIELDS)
      .subscribe((value: any) => {
        if (value && value.documentId === self.documentId && value.fieldName === self.fieldName) {
          this.cdr.detectChanges();
        }
      });

    self.subscriptions.add(subscription);
  }

  ngOnInit() {
    this.loadData();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
